import { ListViewProvider } from './core/ListViewProvider'
import { QueryRequestProvider } from './core/QueryRequestProvider'
import { QueryResponseProvider } from './core/QueryResponseProvider'
import { LogsEncabezados } from './components/header/LogsEncabezados'
import { LogsTable } from './table/LogsTable'
import { KTCard } from '../../../../../_metronic/helpers'

const LogsList = () => {
  return (
    <>
      <KTCard>
        <LogsEncabezados />
        <LogsTable />
      </KTCard>
    </>
  )
}

const LogsListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <LogsList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export { LogsListWrapper }
